import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NavbarToolbarContentService } from './navbar-toolbar-content.service';

@Component({
  selector: 'rezolve-navbar-toolbar-content',
  templateUrl: './navbar-toolbar-content.component.html',
  styleUrls: ['./navbar-toolbar-content.component.scss'],
})
export class NavbarToolbarContentComponent implements OnInit {

  shouldDisplayEmailAddress = false;
  @Output() signatureRequested = new EventEmitter<void>();
  constructor(
    public navbarToolbarContentService: NavbarToolbarContentService)
  { }

  ngOnInit(): void {
    this.navbarToolbarContentService.emailAddress$.subscribe(value => {
      this.shouldDisplayEmailAddress = value != undefined && value != '';
    });
  }

  emitSignatureRequest(): void {
    this.signatureRequested.emit();
  }
}
